import { useFela } from 'react-fela';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { actions as messagesActions } from '@/modules/messages';
import { Button, Icon, Text, useCopyToClipboard } from '@/modules/ui';

import * as felaRules from './SharePrivateLink.rules';

const options = {
    duration: 1,
};

export const SharePrivateLink = () => {
    const { css } = useFela();
    const dispatch = useDispatch();

    const intl = useIntl();

    const { handleCopy } = useCopyToClipboard({
        onSuccess: () => {
            dispatch(
                messagesActions.displaySuccessMessage({
                    message: intl.formatMessage({ id: 'success.secrets.share' }),
                    options,
                }),
            );
        },
        onError: () => {
            dispatch(
                messagesActions.displayErrorMessage({
                    message: intl.formatMessage({ id: 'error.secrets.share' }),
                    options,
                }),
            );
        },
    });

    return (
        <div className={css(felaRules.container)}>
            <Icon type='url' customStyle={felaRules.icon} />
            <div>
                <Text variant='ParagraphNormalRegular'>
                    <FormattedMessage id='secret.share.privateLink.title' />
                </Text>
                <Text variant='ParagraphSmallMedium' color='foregroundsTertiary'>
                    <FormattedMessage id='secret.share.privateLink.description' />
                </Text>
            </div>
            <Button onClick={() => handleCopy(window.location.toString())} customStyle={felaRules.copyButton}>
                <FormattedMessage id='secret.share.copy' />
            </Button>
        </div>
    );
};
